import { Component, Inject, OnInit } from '@angular/core';
import { PlanGestionConvivenciaAdminComponent } from '../../plan-gestion-convivencia-admin/plan-gestion-convivencia-admin.component';

@Component({
  selector: 'app-simulacion-pgc',
  templateUrl: './simulacion-pgc.component.html',
  styleUrls: ['./simulacion-pgc.component.css']
})
export class SimulacionPgcComponent implements OnInit {

  constructor(
    @Inject(PlanGestionConvivenciaAdminComponent) private parent: PlanGestionConvivenciaAdminComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }
}
